module.exports = {"TXTWCL_Less_than_1X":{"id":"TXTWCL_Less_than_1X","defaultMessage":"Under 1 min."}}